/* tslint:disable */
/* eslint-disable */
/**
 * hashicorp/cloud/registry_20250210/service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { Registry20250210GetArtifactResponseFromJSON, Registry20250210GetArtifactVersionResponseFromJSON, Registry20250210ListArtifactVersionInfoResponseFromJSON, Registry20250210ListArtifactsResponseFromJSON, } from '../models';
/**
 *
 */
export class RegistryServiceApi extends runtime.BaseAPI {
    /**
     */
    async getArtifactRaw(requestParameters) {
        if (requestParameters.parentResourceName === null || requestParameters.parentResourceName === undefined) {
            throw new runtime.RequiredError('parentResourceName', 'Required parameter requestParameters.parentResourceName was null or undefined when calling getArtifact.');
        }
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling getArtifact.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/2025-02-10/registry/{parent_resource_name}/artifact/{slug}`.replace(`{${"parent_resource_name"}}`, encodeURIComponent(String(requestParameters.parentResourceName))).replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Registry20250210GetArtifactResponseFromJSON(jsonValue));
    }
    /**
     */
    async getArtifact(parentResourceName, slug) {
        const response = await this.getArtifactRaw({ parentResourceName: parentResourceName, slug: slug });
        return await response.value();
    }
    /**
     */
    async getArtifact2Raw(requestParameters) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling getArtifact2.');
        }
        const queryParameters = {};
        if (requestParameters.parentResourceName !== undefined) {
            queryParameters['parent_resource_name'] = requestParameters.parentResourceName;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/2025-02-10/registry/artifact/{slug}`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Registry20250210GetArtifactResponseFromJSON(jsonValue));
    }
    /**
     */
    async getArtifact2(slug, parentResourceName) {
        const response = await this.getArtifact2Raw({ slug: slug, parentResourceName: parentResourceName });
        return await response.value();
    }
    /**
     * Returns the artifact version and all its information
     */
    async getArtifactVersionRaw(requestParameters) {
        if (requestParameters.parentResourceName === null || requestParameters.parentResourceName === undefined) {
            throw new runtime.RequiredError('parentResourceName', 'Required parameter requestParameters.parentResourceName was null or undefined when calling getArtifactVersion.');
        }
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling getArtifactVersion.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling getArtifactVersion.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/2025-02-10/registry/{parent_resource_name}/artifact/{slug}/version/{version}`.replace(`{${"parent_resource_name"}}`, encodeURIComponent(String(requestParameters.parentResourceName))).replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Registry20250210GetArtifactVersionResponseFromJSON(jsonValue));
    }
    /**
     * Returns the artifact version and all its information
     */
    async getArtifactVersion(parentResourceName, slug, version) {
        const response = await this.getArtifactVersionRaw({ parentResourceName: parentResourceName, slug: slug, version: version });
        return await response.value();
    }
    /**
     * Returns the artifact version and all its information
     */
    async getArtifactVersion2Raw(requestParameters) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling getArtifactVersion2.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling getArtifactVersion2.');
        }
        const queryParameters = {};
        if (requestParameters.parentResourceName !== undefined) {
            queryParameters['parent_resource_name'] = requestParameters.parentResourceName;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/2025-02-10/registry/artifact/{slug}/version/{version}`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Registry20250210GetArtifactVersionResponseFromJSON(jsonValue));
    }
    /**
     * Returns the artifact version and all its information
     */
    async getArtifactVersion2(slug, version, parentResourceName) {
        const response = await this.getArtifactVersion2Raw({ slug: slug, version: version, parentResourceName: parentResourceName });
        return await response.value();
    }
    /**
     * Returns a list of versions with their metadata
     */
    async listArtifactVersionInfoRaw(requestParameters) {
        if (requestParameters.parentResourceName === null || requestParameters.parentResourceName === undefined) {
            throw new runtime.RequiredError('parentResourceName', 'Required parameter requestParameters.parentResourceName was null or undefined when calling listArtifactVersionInfo.');
        }
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling listArtifactVersionInfo.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.sortingOrderBy) {
            queryParameters['sorting.order_by'] = requestParameters.sortingOrderBy;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/2025-02-10/registry/{parent_resource_name}/artifact/{slug}/versions`.replace(`{${"parent_resource_name"}}`, encodeURIComponent(String(requestParameters.parentResourceName))).replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Registry20250210ListArtifactVersionInfoResponseFromJSON(jsonValue));
    }
    /**
     * Returns a list of versions with their metadata
     */
    async listArtifactVersionInfo(parentResourceName, slug, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, sortingOrderBy) {
        const response = await this.listArtifactVersionInfoRaw({ parentResourceName: parentResourceName, slug: slug, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, sortingOrderBy: sortingOrderBy });
        return await response.value();
    }
    /**
     * Returns a list of versions with their metadata
     */
    async listArtifactVersionInfo2Raw(requestParameters) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling listArtifactVersionInfo2.');
        }
        const queryParameters = {};
        if (requestParameters.parentResourceName !== undefined) {
            queryParameters['parent_resource_name'] = requestParameters.parentResourceName;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.sortingOrderBy) {
            queryParameters['sorting.order_by'] = requestParameters.sortingOrderBy;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/2025-02-10/registry/artifact/{slug}/versions`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Registry20250210ListArtifactVersionInfoResponseFromJSON(jsonValue));
    }
    /**
     * Returns a list of versions with their metadata
     */
    async listArtifactVersionInfo2(slug, parentResourceName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, sortingOrderBy) {
        const response = await this.listArtifactVersionInfo2Raw({ slug: slug, parentResourceName: parentResourceName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, sortingOrderBy: sortingOrderBy });
        return await response.value();
    }
    /**
     */
    async listArtifactsRaw(requestParameters) {
        if (requestParameters.parentResourceName === null || requestParameters.parentResourceName === undefined) {
            throw new runtime.RequiredError('parentResourceName', 'Required parameter requestParameters.parentResourceName was null or undefined when calling listArtifacts.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.sortingOrderBy) {
            queryParameters['sorting.order_by'] = requestParameters.sortingOrderBy;
        }
        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/2025-02-10/registry/{parent_resource_name}/artifacts`.replace(`{${"parent_resource_name"}}`, encodeURIComponent(String(requestParameters.parentResourceName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Registry20250210ListArtifactsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listArtifacts(parentResourceName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, sortingOrderBy, search) {
        const response = await this.listArtifactsRaw({ parentResourceName: parentResourceName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, sortingOrderBy: sortingOrderBy, search: search });
        return await response.value();
    }
    /**
     */
    async listArtifacts2Raw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.parentResourceName !== undefined) {
            queryParameters['parent_resource_name'] = requestParameters.parentResourceName;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.sortingOrderBy) {
            queryParameters['sorting.order_by'] = requestParameters.sortingOrderBy;
        }
        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/2025-02-10/registry/artifacts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Registry20250210ListArtifactsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listArtifacts2(parentResourceName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, sortingOrderBy, search) {
        const response = await this.listArtifacts2Raw({ parentResourceName: parentResourceName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, sortingOrderBy: sortingOrderBy, search: search });
        return await response.value();
    }
}
